export default __webpack_public_path__ + "static/media/click.ac0962cd.mp3";